export { default } from './getSiteLink';



// WEBPACK FOOTER //
// ./src/@utils/content/getLinkPath.web.js